var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLupaV3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1875 6.59375C12.1875 7.93848 11.751 9.18066 11.0156 10.1885L14.7246 13.9004C15.0908 14.2666 15.0908 14.8613 14.7246 15.2275C14.3584 15.5938 13.7637 15.5938 13.3975 15.2275L9.68848 11.5156C8.68066 12.2539 7.43848 12.6875 6.09375 12.6875C2.72754 12.6875 0 9.95996 0 6.59375C0 3.22754 2.72754 0.5 6.09375 0.5C9.45996 0.5 12.1875 3.22754 12.1875 6.59375ZM6.09375 10.8125C6.64776 10.8125 7.19635 10.7034 7.7082 10.4914C8.22004 10.2794 8.68511 9.9686 9.07686 9.57686C9.4686 9.18511 9.77936 8.72004 9.99137 8.2082C10.2034 7.69635 10.3125 7.14776 10.3125 6.59375C10.3125 6.03974 10.2034 5.49115 9.99137 4.9793C9.77936 4.46746 9.4686 4.00239 9.07686 3.61064C8.68511 3.2189 8.22004 2.90815 7.7082 2.69613C7.19635 2.48412 6.64776 2.375 6.09375 2.375C5.53974 2.375 4.99115 2.48412 4.4793 2.69613C3.96746 2.90815 3.50239 3.2189 3.11064 3.61064C2.7189 4.00239 2.40815 4.46746 2.19613 4.9793C1.98412 5.49115 1.875 6.03974 1.875 6.59375C1.875 7.14776 1.98412 7.69635 2.19613 8.2082C2.40815 8.72004 2.7189 9.18511 3.11064 9.57686C3.50239 9.9686 3.96746 10.2794 4.4793 10.4914C4.99115 10.7034 5.53974 10.8125 6.09375 10.8125Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLupaV3);
export default __webpack_public_path__ + "static/media/lupaV3.8002fe8880fc27d796dc29fdbd83118a.svg";
export { ForwardRef as ReactComponent };